<div class="footer-wrapper">
  <div class="footer-background-pattern"></div>
  <div class="footer-container">
    <div class="footer-content">
      <!-- Brand Section -->
      <div class="footer-brand">
        <div class="footer-brand-header">
          <img class="footer-logo" src="assets/images/logo-tnd-white.png" alt="TND Value" />
        </div>
        <p class="footer-description">
          TND Value là đối tác tư vấn thẩm định tin cậy với hơn 16 năm kinh nghiệm trong lĩnh vực thẩm định giá tài
          sản, đảm bảo chính xác và minh bạch.
        </p>
        <div class="footer-social">
          <a href="#" class="footer-social-link" aria-label="Facebook">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
            </svg>
          </a>
          <a href="#" class="footer-social-link" aria-label="LinkedIn">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
              <rect x="2" y="9" width="4" height="12" />
              <circle cx="4" cy="4" r="2" />
            </svg>
          </a>
          <a href="#" class="footer-social-link" aria-label="Zalo">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path
                d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
            </svg>
          </a>
        </div>
      </div>

      <!-- Quick Links Section -->
      <div class="footer-section">
        <h4 class="footer-section-title">Dịch vụ</h4>
        <ul class="footer-links">
          <li><a href="#" class="footer-link">Thẩm định giá Bất Động Sản</a></li>
          <li><a href="#" class="footer-link">Thẩm định giá Động Sản</a></li>
          <li><a href="#" class="footer-link">Thẩm định giá Doanh Nghiệp</a></li>
          <li><a href="#" class="footer-link">Thẩm định giá Dự Án</a></li>
        </ul>
      </div>

      <!-- Contact Section -->
      <div class="footer-section">
        <h4 class="footer-section-title">Liên hệ</h4>
        <div class="footer-contact-grid">
          <div class="footer-contact-item">
            <div class="footer-contact-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </div>
            <a href="https://www.google.com/maps/place/328A+Đ.+Phan+Đình+Phùng,+Phường+1,+Phú+Nhuận,+Hồ+Chí+Minh,+Việt+Nam/@10.7984855,106.6781101,17z/data=!4m15!1m8!3m7!1s0x317528d7206bd73f:0xbc5ee1a3a230fbd2!2zMzI4QSDEkC4gUGhhbiDEkMOsbmggUGjDuW5nLCBQaMaw4budbmcgMSwgUGjDuiBOaHXhuq1uLCBI4buTIENow60gTWluaCwgVmnhu4d0IE5hbQ!3b1!8m2!3d10.7984802!4d106.6806904!16s%2Fg%2F11h89s95hb!3m5!1s0x317528d7206bd73f:0xbc5ee1a3a230fbd2!8m2!3d10.7984802!4d106.6806904!16s%2Fg%2F11h89s95hb?entry=ttu&amp;g_ep=EgoyMDI1MDkxMC4wIKXMDSoASAFQAw%3D%3D"
              target="_blank" rel="noopener" class="footer-contact-text">
              328A Phan Đình Phùng, Phường Cầu Kiệu, TP.HCM
            </a>
          </div>

          <div class="footer-contact-item">
            <div class="footer-contact-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path
                  d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
            </div>
            <a href="tel:02873001112" class="footer-contact-text">02873001112 - 02873001114</a>
          </div>

          <div class="footer-contact-item">
            <div class="footer-contact-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect width="20" height="16" x="2" y="4" rx="2" />
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
              </svg>
            </div>
            <a href="mailto:contact&#64;tndvalue.com" class="footer-contact-text">contact&#64;tndvalue.com</a>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-divider"></div>

    <div class="footer-bottom">
      <div class="footer-bottom-left">
        <p class="footer-copyright">© 2024 TND Value. Tất cả quyền được bảo lưu.</p>
        <p class="footer-legal">
          ĐKKD số 0102658944 do Sở Kế Hoạch Và Đầu Tư Thành Phố Hà Nội cấp ngày 29 tháng 02 năm 2008
          | <a href="/chinh-sach-bao-mat-thong-tin" class="hover:underline">Chính sách bảo mật</a>
        </p>
      </div>
      <div class="footer-bottom-right">
        <p class="footer-version">Version {{version}}</p>
      </div>
    </div>
  </div>
</div>